export default {
  message: {
    assetDistribution: "资产分布",
    fixedReturn: "固定收益",
    trust: "信託",
    summary: "总览",
    creditCard: "信用卡",
    cashMangement: "现金托管",
    othersAssets: "Others Assets",
    myassetDistribution: "我的资产分布",
    elite: "晋永财富传承信托计划",
    signature: "汇智创富信托计划",
    timelessVenture: "Timeless Venture Capital Fund",
    plan: "计划",
    planName: "计划名称",
    newPlan: "新计划",
    updatePlan: "修改计划",
    subscriptedPlan: "认购计划",
    subscriptedPlanEN: "认购计划 (英)",
    subscriptedPlanZH: "认购计划 (中)",
    customerCode: "客户编号",
    currency: "货币",
    validDate: "生效日期",
    expiryDate: "到期日",
    balanceAmount: "结余金额",
    expectedAnnualReturn: "预计年化分配率",
    actualAnnualReturn: "实际年化分配率（每月更新）",
    beneficiary: "生前受益人",
    beneficiaryDeath: "身故受益人",
    details: "详情",
    overview: "总览",
    totalConFromEffectiveDate: "自账户生效日起计的总净供款",
    totalConTransInAssets: "总供款/转入资产",
    totalWithTransOutAssets: "总提取/转出资产",
    profitorLossFromEffectiveDate: "自账户生效日起计的投资收益/亏损",
    accountBalance: "帐户结存",
    accountReturns: "帐户回报",
    quarterFundOverview: "季度基金概览",
    notifications: "通知",
    addNotifications: "新增通知",
    newNotifications: "新通知",
    date: "日期",
    subject: "标题",
    detail: "内容",
    contactUs: "联系我们",
    agentNo: "信托专员编号",
    lastUpdate: "最后更新",
    customer: "客户",
    customerName: "客户名称",
    addCustomer: "新增客户",
    newCustomer: "新客户",
    updateCustomer: "编辑客户",
    profile: "个人资料",
    logout: "退出",
    hkd: "港元",
    back: "返回",
    confirm: "确定",
    update: "更新",
    cancel: "取消",
    add: "新增",
    name: "姓名",
    email: "电子邮件",
    content: "信息",
    send: "发送",
    gender: "性别",
    phone: "电话",
    dateOfBirth: "出生年月",
    residentialAddress: "住宅地址",
    corrAddress: "通讯地址",
    confirmPwd: "确认密码",
    resetPwd: "重设密码",
    No: "编号",
    nickName: "名称",
    balance: "结存",
    returns: "回报",
    selectFile: "选择档案",
    user: "用户",
    staff: "职员",
    addUser: "新增用户",
    newUser: "新用户",
    username: "用户名",
    updateUser: "编辑用户",
    role: "角色",
    password: "密码",
    agentNumber: "信托专员编号",
    createdAt: "创建日期",
    goLogin: "请重新登入。",
    USD: "美元 ",
    HKD: "港元 ",
    EUR: "欧元 ",
    RMB: "人民币 ",
    male: "男",
    female: "女",
    edit: "编辑",
    pwdError: "两次输入的密码不一致",
    sendSuccess: "发送成功",
    errorMsg: "错误，请检查后重新提交。",
    editPwd: "修改密码",
    agent: "信托专员",
    clickHere: "点击此处",
    signIn: "登入",
    goSignIn: "去登入?",
    forgotPwd: "忘记密码？",
    partnerOf: "合作伙伴:",
    checkEmail: "发送成功，请查阅您的邮箱。",
    checkEmail2: "已发送激活电邮至 ",
    checkEmail3: " , 请查阅邮箱。",
    checkEmail4: "已发送电邮至 ",
    accountError: "用户名或者密码错误，请重新输入。",
    oldPwd: "旧密码",
    oldPwdErrorMsg: "旧密码错误，请重新尝试。",
    approvalUser: "用户审批",
    pendingApproval: "待审批",
    approved: "已批准",
    errorDel: "删除失败，请重新尝试。",
    delete: "删除",
    newPwd: "新密码",
    newRePwd: "再次输入新密码",
    setPwd: "发送成功",
    planTemplate: "计划范本",
    addPlanTemplate: "新增范本",
    planTemplateZH: "计划名称(中)",
    planTemplateEN: "计划名称(英)",
    interestRate: "年利率(%)",
    dividendPeriod: "派息周期(月)",
    length: "计划年期(月)",
    manageFee: "管理费(%)",
    managePeriod: "管理费收费周期(月)",
    newPlanTemplate: "新计划范本",
    updatePlanTemplate: "编辑计划范本",
    createSuccess: "新增成功",
    updateSuccess: "更新成功",
    deleteSuccess: "删除成功",
    dividendMode: "派息模式",
    dividend: "派息",
    periods: "期数",
    dividendDate: "派息日期",
    interestRate1: "利率",
    interest: "利息",
    manageFee1: "管理费",
    interest1: "回报",
    grossInterest: "年度派息",
    accumulated: "累积利息",
    rolloverAmount: "复利息后客户所得总额",
    status: "状态",
    capital: "本金",
    chooseTemplate: "选择计划范本",
    dividendApproval: "收益分配安排",
    simple: "每年提取",
    compound: "滚存生息",
    halfYearly: "每半年提取",
    onHold: "排程中",
    pending: "审批中",
    approve: "批准",
    reject: "不批准",
    rejected: "不批准",
    issued: "已派息",
    expired: "已过期",
    complete: "完成派息",
    submit: "提交",
    clientCode: "客户编号",
    clientName: "客户名称",
    must_be_number: "必须是数字",

    changePassword: "更改密码",
    currentPassword: "当前密码",
    newPassword: "新密码",
    confirmNewPassword: "确认新密码",
    enterCurrentPassword: "请输入当前密码",
    enterNewPassword: "请输入新密码",
    confirmNewPasswordPlaceholder: "请确认新密码",
    updatePassword: "更新密码",
    clear: "清除",
    error: "错误",
    success: "成功",
    passwordMismatch: "新密码与确认密码不一致",
    passwordLengthError: "密码长度至少需要6个字符",
    passwordUpdateSuccess: "密码更新成功",
    currentPasswordIncorrect: "当前密码不正确",
    passwordUpdateFailed: "密码更新失败",
    passwordUpdateError: "更新密码时发生错误",
    searchCustomer: "按姓名、代码、用户名、电邮或电话搜索",
    clearSearch: "清除搜索",
    fixedTermStatement: "《固定期限安排之责任声明》：此账户上显示的信托为委托人要求设立的不可撤销信托，且就所涉固定期限安排（“固定期限安排”），委托人是经充分考虑后，自主选择将相关信托资产配置于具固定期限、流动性限制及/或提前退出限制之安排，并知悉该安排可能涉及由独立第三方机构根据其自身法律及商业条款管理、持有、配置或执行。委托人进一步确认，相关资产一经依其明确书面指示配置至上述安排后，将受适用之交易文件、相关第三方安排文件及/或其他具法律约束力文件规范，并非由受托人单方面控制或可由受托人单方面任意解除、撤回、变更或提前退出。在固定期限內，任何提前赎回、提前退出、资产转移、信托终止、变更 or 分配要求（如有），须受本信托契约、本条款、相关第三方安排条款及适用法律约束，并可能因提前处置导致损失、罚则、流动性受限、价值受损或其他不利后果。委托人确认并接受该等风险。而受托人于处理任何该等要求时，应有权根据信托契约、相关交易安排、第三方约束及其作为受托人之职责，审慎考虑相关因素，包括但不限于对信托资产之保全、受益人整体利益、既有法律义务及相关安排下可能产生之风险与后果。委托人确认在固定期限安排项下任何预计年化分配率（如有）乃由相关独立第三方提供，仅属说明性质，并不构成受托人就收益、表现或结果作出任何保证、承诺或担保。受托人仅依信托契约履行行政及托管职责，并不作为投资经理、投资顾问或回报保证人。除另有明确约定外，相关预计年化分配率（如适用）已反映并预先扣除受托人按信托资产总值每年收取之托管及行政费用。本条款应与主信托契约一并阅读；如有不一致，应按主信托契约及适用法律解释，并在可适用范围内，使本条款充分反映委托人就固定期限安排之明确指示及各方原意。",
  },

  lang: {
    hi: "您好",
    total_balance: "总可用资产",
    total_credit: "总信用资产",
    currency: "货币计价单位",
    welcome: "欢迎来到您的信托帐户",
    total_amount_of_fixed_custody: "定期信托托管份额",
    total_amount_of_current_custody: "托管资产净值",
    fixed_custody_account_number: "定期托管编号",
    current_custody_account_number: "托管资产净值编号",
    demand_trust_amount: "活存托管总金额",
    trust_advisor_number: "信托顾问编号",
    trust_account_id: "信托编号",
    total_amount: "信托资产总额",
    account_number: "帐户活存编号",
    add_new: "添新",
    update_card: "更新卡",
    update_summary: "更新总结",
    create_fixed_trust_account: "定存账户编号",
    update_fixed_trust_account: "更新定存信托账户",
    create_demand_trust_amount: "创建活存信托金额",
    update_demand_trust_amount: "更新活存信托金额",
    summary_total_amount: "信托资产总额",
    fixed_trust_account_number: "活存信托帐号",
    demand_deposit_trust_amount_acount_number: "活存信托金额 帐号",

    credit_card: "信用卡",
    cash: "现金",
    fixed_return: "固定收益",
    fixed_custody: "定期信托托管份额",
    current_custody: "托管资产净值",

    card_number: "卡号",
    expiry_date: "有效期限",
    card_holder_name: "持卡人姓名",
    total_credit_limit: "总信用额度",
    used_credit: "已用额度",
    remaining_limit: "剩余额度",

    latest_transactions: "近五笔交易明细",
    just_latest_transactions: "最新交易",
    create_transactions: "创建交易",
    update_transactions: "更新交易",
    spending_date: "支付日期",
    deduct_date: "扣款日期",
    spending_detail: "支付明细",
    spending_location: "支付地",
    international_ex_fee: "本地消费金额",
    usd_deduct_amount: "美元扣款金额",
    fx_charge_date: "外币折算日",
    currency_type: "外币币别/金额",

    fixed_custody_number: "定期序号",
    effective_date: "生效日期",
    maturity_date: "到期日",
    management_currency: "货币",
    custody_amount: "托管资产",
    standard_return: "预计年化分配率",
    beneficiary: "生前受益人",
    beneficiary_after_death: "身故受益人",
    note: "备注",
    deposit_withdrawal: "注入／分配",
    amount: "资产",
    account_balance: "托管余额",
    initial_deposit: "初始信托资本",
    interest_deposit: "收益分配",
    details: "详情",
    deposit: "存入",
    withdrawal: "支出",
    usd: "美元",
    asset_type: "资产类别",
    unit: "单位",
    asset_total: "总资产价值/总预估价值",
    others_assets: "其他资产",
    add_other_asset: "添加其他资产",
    update_other_asset: "更新其他资产",
    before_beneficiary: "生前受益人",
    after_beneficiary: "身故受益人",
    remark: "备注",
  },
};
